import request from '@/axios';

export const getList = (params) => {
    return request({
        url: '/lebo-ad/ad/channelAreaDaymax/page',
        method: 'get',
        params: params
    })
}

export const getDetail = (id) => {
    return request({
        url: `/lebo-ad/ad/channelAreaDaymax/info/${id}`,
        method: 'get'
    })
}

export const add = (data) => {
    return request({
        url: '/lebo-ad/ad/channelAreaDaymax/save',
        method: 'post',
        data: data
    })
}

export const update = (data) => {
    return request({
        url: '/lebo-ad/ad/channelAreaDaymax/update',
        method: 'post',
        data: data
    })
}

export const remove = (ids) => {
    return request({
        url: '/lebo-ad/ad/channelAreaDaymax/delete',
        method: 'post',
        data: ids
    })
}
